<template>
  <div
    class="
      h-screen
      flex
      w-full
      bg-img
      vx-row
      no-gutter
      justify-center
      items-center
    "
  >
    <div
      class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4"
      style="transform: translateY(-50%)"
    >
      <vx-card>
        <div class="vx-card__title mb-6">
          <h2 class="text-center">
            {{ completionTitle }}
          </h2>
          <p class="text-center">
            {{ completionMessage }}
          </p>
          <br />
          <p class="text-center">
            {{ completionNumber }}
          </p>
          <div class="flex flex-wrap justify-center">
            <vs-button
              icon-pack="feather"
              icon="icon-eye"
              class="mt-4"
              @click="handleViewClick"
              :disabled="orderApprovalFlowEnabled === null"
            >
              {{ buttonText }}
            </vs-button>
          </div>
          <p class="text-center mt-4">
            This page will close in {{ seconds }} seconds.....
          </p>
        </div>
      </vx-card>
      <ShopFeedback @onSubmit="handleSubmitFeedback" :active="feedBackActive" :step="feedbackStep" @onClose="handleClose"/>
    </div>
  </div>
</template>

<script>
import ShopFeedback from './feedbackSurvey.vue';
import { mapActions } from 'vuex';
import { currentUserIsDoctor } from '@/globalHelpers/userRole';
import { ORDER_COMPLETE_MESSAGES, ORDER_COMPLETE_FORMATS } from './orderCompleteConstants';

export default {
  name: 'ClinicOrderComplete',
  inject: ['getRoleRouteName'],
  components: {
    ShopFeedback,
  },
  data() {
    return {
      orderId: '',
      orderNumber: '',
      seconds: 10,
      interval: null,
      feedBackActive: false,
      userId: '',
      feedbackStep: 1,
      orderApprovalFlowEnabled: true,
      payToPending: false,
    };
  },
  computed: {
    isUSRegion() {
      return process.env.VUE_APP_REGION === 'US';
    },
    completionTitle() {
      if (this.orderApprovalFlowEnabled === null) return ORDER_COMPLETE_MESSAGES.TITLE.LOADING;
      // FRH-745: takes priority over the region/approval-flow checks below —
      // a held PayTo order is never "Completed" yet, regardless of region.
      if (this.payToPending) return ORDER_COMPLETE_MESSAGES.TITLE.PAYTO_PENDING;
      if (this.isUSRegion) return ORDER_COMPLETE_MESSAGES.TITLE.ORDER_COMPLETED;
      return this.orderApprovalFlowEnabled
        ? ORDER_COMPLETE_MESSAGES.TITLE.FORECAST_SUBMITTED
        : ORDER_COMPLETE_MESSAGES.TITLE.ORDER_COMPLETED;
    },
    completionMessage() {
      if (this.orderApprovalFlowEnabled === null) return ORDER_COMPLETE_MESSAGES.MESSAGE.LOADING;
      if (this.payToPending) return ORDER_COMPLETE_MESSAGES.MESSAGE.PAYTO_PENDING;
      if (this.isUSRegion) return ORDER_COMPLETE_MESSAGES.MESSAGE.ORDER_PLACED;
      return this.orderApprovalFlowEnabled
        ? ORDER_COMPLETE_MESSAGES.MESSAGE.FORECAST_SUBMITTED
        : ORDER_COMPLETE_MESSAGES.MESSAGE.ORDER_PLACED;
    },
    completionNumber() {
      if (this.orderApprovalFlowEnabled === null) return ORDER_COMPLETE_MESSAGES.MESSAGE.LOADING;
      if (this.isUSRegion) {
        return this.orderNumber
          ? ORDER_COMPLETE_FORMATS.ORDER_NUMBER(this.orderNumber)
          : ORDER_COMPLETE_MESSAGES.MESSAGE.LOADING;
      }
      if (this.orderApprovalFlowEnabled) {
        return this.requestNumber
          ? ORDER_COMPLETE_FORMATS.FORECAST_NUMBER(this.requestNumber)
          : ORDER_COMPLETE_MESSAGES.MESSAGE.LOADING;
      }
      return this.orderNumber
        ? ORDER_COMPLETE_FORMATS.ORDER_NUMBER(this.orderNumber)
        : ORDER_COMPLETE_MESSAGES.MESSAGE.LOADING;
    },
    buttonText() {
      if (this.orderApprovalFlowEnabled === null) return ORDER_COMPLETE_MESSAGES.BUTTON.LOADING;
      return this.isUSRegion || !this.orderApprovalFlowEnabled
        ? ORDER_COMPLETE_MESSAGES.BUTTON.VIEW_ORDER
        : ORDER_COMPLETE_MESSAGES.BUTTON.VIEW_FORECASTS;
    },
  },
  created() {
    this.orderId = this.$route.query.orderId;
    this.orderNumber = this.$route.query.orderNumber;
    this.requestId = this.$route.query.requestId;
    this.requestNumber = this.$route.query.requestNumber;
    const daf = this.$route.query.doctorApprovalFlow;
    this.orderApprovalFlowEnabled =
      daf == null ? true : String(Array.isArray(daf) ? daf[0] : daf).toLowerCase() !== 'false';
    // Presentational only, and trusted as-is — it only decides which copy
    // renders below, not any actual order state. This page already has
    // orderId if it ever needs to look the real status up.
    const payToPending = this.$route.query.payToPending;
    this.payToPending = String(Array.isArray(payToPending) ? payToPending[0] : payToPending).toLowerCase() === 'true';
    // If param approval flow is true but user is a doctor, set it to false
    if (this.orderApprovalFlowEnabled && currentUserIsDoctor()) {
      this.orderApprovalFlowEnabled = false;
    }
    this.feedBackActive = true;
    this.userId =JSON.parse(localStorage.getItem(
      `${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`,
    ))._id;
  },
  methods: {
    ...mapActions('ecommerce', ['saveFeedback']),
    async handleSubmitFeedback(val) {
      try {
        if(val.reaction !== '' && val.remarks !== ''){
          const payload = {...val};
          payload.userId = this.userId;
          payload.metadata = {
            clinicId: sessionStorage.getItem('doctorClinicSelectedClinic'),
          };
          if (this.orderApprovalFlowEnabled) {
            payload.metadata.requestNumber = this.requestNumber;
            payload.metadata.requestId = this.requestId;
          } else {
            payload.metadata.orderId = this.orderId;
          }
          payload.slug = 'shop-orders-feedback';
          await this.saveFeedback(payload);

        }
        this.feedbackStep = 2;
        
      } catch (error) {
        console.error(error);
      }
    },
    handleClose() {
      this.feedBackActive = false;
      this.counter();
    },
    counter() {
      const self = this;
      this.interval = setInterval(function () {
        if (self.seconds == 0) {
          clearInterval(self.interval);

          if (self.orderApprovalFlowEnabled) {
            self.$router.push({
              name: self.getRoleRouteName('OrderList'),
              query: { tab: 2 },
            })
              .catch((e) => console.warn(e));
          } else {
            self.$router.push({
              name: self.getRoleRouteName('OrderDetail'),
              params: { orderId: self.orderId },
            })
              .catch((e) => console.warn(e));
          }

        } else console.log('Currently at ' + self.seconds--);
      }, 1000);
    },
    viewOrderRoute() {
      clearInterval(this.interval);
      this.$router
        .push({ name: this.getRoleRouteName('OrderDetail'), params: { orderId: this.orderId } })
        .catch(() => {});
    },
    viewOrderRequestsRoute() {
      clearInterval(this.interval);
      this.$router
        .push({ name: this.getRoleRouteName('OrderList'), query: { tab: 2 } })
        .catch(() => {});
    },
    handleViewClick() {
      if (this.isUSRegion || !this.orderApprovalFlowEnabled) {
        this.viewOrderRoute();
      } else {
        this.viewOrderRequestsRoute();
      }
    },
  },
  destroyed() { 
    clearInterval(this.interval);
  },
};
</script>

<style scoped></style>
